$(document).ready(function() {
  const phoneInput = $('.phone-number-input');

  if (phoneInput.length === 0) {
    return;
  }

  phoneInput.intlTelInput({
    initialCountry: 'FR',
    preferredCountries: ['FR'],
    separateDialCode: true,
    formatOnDisplay: true,
    autoHideDialCode: false,
    nationalMode: false,
    hiddenInput: 'phone_number',
    utilsScript: 'https://cdnjs.cloudflare.com/ajax/libs/intl-tel-input/17.0.8/js/utils.min.js',
  });

  phoneInput.closest('f').on('submit', function(e) {
    if (phoneInput.intlTelInput('isValidNumber') &&
        [
          intlTelInputUtils.numberType.MOBILE,
          intlTelInputUtils.numberType.FIXED_LINE_OR_MOBILE,
        ].includes(phoneInput.intlTelInput('getNumberType'))) {
      phoneInput.val(phoneInput.intlTelInput('getNumber'));
    } else {
      e.preventDefault();
      phoneInput.addClass('bg-red-100');
      return false;
    }
  });

  // Toggle and clear fiscal address fields

  const fiscalBoolean = $('#users_profile_user_attributes_has_separate_fiscal_address');
  const fiscalAddressFields = $('#fiscal-address-fields');

  fiscalBoolean.on('change', (e) => {
    if (e.target.checked) {
      $('#fiscal-address-fields').removeClass('d-none');
    } else {
      $('#fiscal-address-fields').addClass('d-none');

      $("input", fiscalAddressFields).each((_, inputElement) => {
        clearInputField(inputElement);
      });

      $('select', '#fiscal-address-fields').val(null);
    }
  })
});

const clearInputField = (inputElement) => {
  inputElement.value = null;
};
